// extracted by mini-css-extract-plugin
export default {"toc":"NtrpScale_toc__qtDqX","levelBlock":"NtrpScale_levelBlock__UdtaK","strengthWeakTable":"NtrpScale_strengthWeakTable__kghA6"};